let lang = languageAttributes.content_lang ? languageAttributes.content_lang : languageAttributes.languageCode;

let tc = require('../../content/hi_hi/tc_tabs.json') ;


let content = [
    {
      id: "general_trading_conditions",
      title: tc.product_details_title,
      tabs: [
        {
          //id: "product_details",
          id:"tc-view-6",
          title: tc.product_details_tab_title,
          content_before: `<p class="mb-5">
                            ${tc.product_details_p1}
                            <br><br>
                            ${tc.product_details_p2}
                            <br><br>
                            ${tc.product_details_p3}
                            <br><br>
                            ${tc.product_details_p4}
                            <br><br>
                            ${tc.product_details_p5}
                            <br><br>
                            ${tc.product_details_p6}
                            </p>
                            <span id="product_section"></span>
                            <p class="tc-inner-link">${tc.product_details_tab1}</p>
                            <p class="tc-inner-link">${tc.product_details_tab2}</p>
                            <p class="tc-inner-link">${tc.product_details_tab3}</p>
                            <p class="tc-inner-link">${tc.product_details_tab4}</p>
                            <p class="tc-inner-link">${tc.product_details_tab5}</p>
                            <p class="tc-inner-link">${tc.product_details_tab6}</p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "trading_hours",
          id: "tc-view-2",
          title: tc.trading_hours_tab_title,
          content_before: `<p>
            ${tc.trading_hours_p1}
                
              <br><br>
              ${tc.trading_hours_p2}
              </p>`,
  
          data_id: "TradingHours",
          
          products: {
            1: tc.trading_hours_product1 ,
            2: tc.trading_hours_product2 ,
            3: tc.trading_hours_product3 ,
            4: tc.trading_hours_product4 ,
            5: tc.trading_hours_product5 ,
            8: tc.trading_hours_product6 
          },
          table_titles: [
            tc.trading_hours_table_th1,
            tc.trading_hours_table_th2,
            tc.trading_hours_table_th3,
            tc.trading_hours_table_th4,
            tc.trading_hours_table_th5
          ],
          content_after: `${tc.trading_hours_p3}`,
        },
       
        {
          //id: "holidays",
          id: "tc-view-4",
          title: tc.holidays_tab_title,
          content_before: `<p>
              ${tc.holidays_p1}<br>
              ${tc.holidays_p2}<br>
              ${tc.holidays_p3}
              </p>`,
  
          data_id: "Holidays",
          table_titles: [
            tc.holidays_table_th1,
            tc.holidays_table_th2,
            tc.holidays_table_th3
          ],
          content_after: `<p class="mt-4">${tc.holidays_p4}</p>`,
        },
        {
          //id: "orders_and_execution",
          id: "tc-view-23",
          title: tc.orders_and_execution_tab_title,
          content_before: `<p><b>${tc.orders_and_execution_p1}</b></p>
  
              <table class="mb-4 table4">
                  <tbody>
                      <tr>
                          <th>${tc.orders_and_execution_t1_p1}</th>
                          <th></th>
                      </tr>
                      <tr>
                          <td>${tc.orders_and_execution_t1_p2}</td>
                          <td>${tc.orders_and_execution_t1_p3}</td>
                      </tr>
                      <tr>
                      <td>${tc.orders_and_execution_t1_p4}</td>
                          <td>${tc.orders_and_execution_t1_p5}</td>
                      </tr>
                  </tbody>
              </table>
  
               <table class="mb-4 table4">
                  <tbody>
                      <tr>
                          <th>${tc.orders_and_execution_t2_p1}</th>
                          <th></th>
                      </tr>
                      <tr>
                          <td>${tc.orders_and_execution_t2_p2}</td>
                          <td>${tc.orders_and_execution_t2_p3}</td>
                      </tr>
                      <tr>
                      <td>${tc.orders_and_execution_t2_p4}</td>
                          <td>${tc.orders_and_execution_t2_p5}</td>
                      </tr>
                  </tbody>
              </table>
  
              <p>
                  <b>${tc.orders_and_execution_p2}</b><br>
                  ${tc.orders_and_execution_p3}
              </p>
              <p>
              <b>${tc.orders_and_execution_p4}</b><br>
              ${tc.orders_and_execution_p5}<br><br>
              ${tc.orders_and_execution_p6}
              </p>
              <p>
              <b>${tc.orders_and_execution_p7}</b><br>
              ${tc.orders_and_execution_p8}
              </p>
              <p>
              <b>${tc.orders_and_execution_p9}</b><br>
              ${tc.orders_and_execution_p10}<br><br>
              ${tc.orders_and_execution_p11}
              </p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "negative_balance_protection",
          id: "tc-view-20",
          title: tc.negative_balance_tab_title,
          content_before: `<p class="">
                 ${tc.negative_balance_protection_p1}
                <br class="br3-hide"><br class="br3-hide">
                ${tc.negative_balance_protection_p2}
              </p>`,
          data_id: "",
          content_after: "",
        },
       
       
          
        {
          //id: "bonus_terms_and_conditions",
          id:'btc',
          title: tc.bonus_tc_tab_title,
          content_before: `
                 
                      <p>
                          <b>${tc.bonus_tc_p1}</b><br>${tc.bonus_tc_p2}
                      </p>
                      <p>
                          <b>${tc.bonus_tc_p3}</b><br>${tc.bonus_tc_p4}
                          <br><br>
                          ${tc.bonus_tc_p5}
                          <br><br>
                          ${tc.bonus_tc_p6}<br><br>
                          ${tc.bonus_tc_p7}
                      </p>
                      
                      <p>
                          <b>${tc.bonus_tc_p8}</b><br>
                          ${tc.bonus_tc_p9}
                          <br><br>
                          ${tc.bonus_tc_p10}
                          <br><br>
                          ${tc.bonus_tc_p11}
                          <br><br>
                          ${tc.bonus_tc_p12}
                      </p>
                   
                      <ul class="list-style-dashed">
                      <li class="mb-2 mt-1">${tc.bonus_tc_p14}</li>
                    
                      </ul>
                      <p>
                          <u style="font-style:italic">${tc.bonus_tc_p16}</u><br><br>
                          ${tc.bonus_tc_p17}<br><br>
                          ${tc.bonus_tc_p18}
                      </p>
          
                      <div class="table-wrapper">
                          <table class="table2 mt-4 mb-4 w-auto">
                              <tbody><tr>
                                  <th>${tc.th_balance}</th>
                                  <th>${tc.th_equity}</th>
                                  <th>${tc.th_margin_available}</th>
                                  <th>${tc.th_trading_bonus}</th>
                              </tr>
                              <tr>
                                  <td>$1,000</td>
                                  <td>$1,000</td>
                                  <td>$1,300</td>
                                  <td>$300</td>
                              </tr>
                          </tbody></table>
                      </div>
          
                      <p>
                      ${tc.bonus_tc_p19}
                          <br><br>
                          <u style="font-style:italic">${tc.bonus_tc_p20}</u><br><br>
                          ${tc.bonus_tc_p21}
                      </p>
          
                      <div class="table-wrapper">
                          <table class="table2 mt-4 mb-4 w-auto">
                              <tbody><tr>
                                  <th>${tc.th_balance}</th>
                                  <th>${tc.th_equity}</th>
                                  <th>${tc.th_margin_available}</th>
                                  <th>${tc.th_trading_bonus}</th>
                              </tr>
                              <tr>
                                  <td>$1,000</td>
                                  <td>$1,000</td>
                                  <td>$1,300</td>
                                  <td>$300</td>
                              </tr>
                          </tbody></table>
                      </div>
          
                      <p>
                          <u style="font-style:italic">${tc.bonus_tc_p22}</u><br><br>
                          ${tc.bonus_tc_p23}<br><br>
                          ${tc.bonus_tc_p24}
                      </p>
          
                      <div class="table-wrapper">
                          <table class="table2 mt-4 mb-4 w-auto">
                              <tbody><tr>
                                  <th>${tc.th_balance}</th>
                                  <th>${tc.th_equity}</th>
                                  <th>${tc.th_margin_available}</th>
                                  <th>${tc.th_trading_bonus}</th>
                              </tr>
                              <tr>
                                  <td>$0</td>
                                  <td>$0</td>
                                  <td>$0</td>
                                  <td>$0</td>
                              </tr>
                          </tbody></table>
                      </div>
                     
                      <p>
                          <u style="font-style:italic">${tc.bonus_tc_p25}</u>
                          <br><br>
                          ${tc.bonus_tc_p26}
                          <br><br>
                          ${tc.bonus_tc_p27}
                      </p>
                      <div class="table-wrapper">
                          <table class="table2 mt-4 mb-4 w-auto">
                              <tbody><tr>
                                  <th>${tc.th_balance}</th>
                                  <th>${tc.th_equity}</th>
                                  <th>${tc.th_margin_available}</th>
                                  <th>${tc.th_trading_bonus}</th>
                              </tr>
                              <tr>
                                  <td>$200</td>
                                  <td>$200</td>
                                  <td>$200</td>
                                  <td>$0</td>
                              </tr>
                          </tbody></table>
                      </div>
          
                      <p>${tc.bonus_tc_p28}</p>
                 
                      
                      <p>
                          <b>${tc.bonus_tc_p29}</b><br>
                          ${tc.bonus_tc_p30}<br><br>
                          ${tc.bonus_tc_p31}
                      </p>
                      <p>
                          <u style="font-style:italic">${tc.bonus_tc_p32}</u><br><br>
                          ${tc.bonus_tc_p33}<br><br>
                          ${tc.bonus_tc_p34}
                      </p>
                      <div class="table-wrapper">
                          <table class="table2 mt-3 mb-4 w-auto">
                              <tbody><tr>
                                  <th>${tc.th_balance}</th>
                                  <th>${tc.th_equity}</th>
                                  <th>${tc.th_margin_available}</th>
                                  <th>${tc.th_pending_bonus}</th>
                                  <th>${tc.th_volume_traded}</th>
                                  <th>${tc.th_volume_required}</th>
                              </tr>
                              <tr>
                                  <td>$1,000</td>
                                  <td>$1,000</td>
                                  <td>$1,000</td>
                                  <td>$400</td>
                                  <td>$0</td>
                                  <td>$20,000,000</td>
                              </tr>
                          </tbody></table>
                      </div>
                      
                      <p>
                          ${tc.bonus_tc_p35}<br><br>
                          ${tc.bonus_tc_p36}
                          <br><br>
                          <u style="font-style:italic">${tc.bonus_tc_p37}</u><br><br>
                          <u style="font-style:italic">${tc.bonus_tc_p38}</u><br><br>
                          ${tc.bonus_tc_p39}<br><br>
                          ${tc.bonus_tc_p40}
                      </p>
          
                      <div class="table-wrapper">
                          <table class="table2 mt-4 mb-4 w-auto">
                              <tbody><tr>
                                  <th>${tc.th_balance}</th>
                                  <th>${tc.th_equity}</th>
                                  <th>${tc.th_margin_available}</th>
                                  <th>${tc.th_pending_bonus}</th>
                                  <th>${tc.th_volume_traded}</th>
                                  <th>${tc.th_volume_required}</th>
                              </tr>
                              <tr>
                                  <td>$1,100</td>
                                  <td>$1,100</td>
                                  <td>$1,100</td>
                                  <td>$300</td>
                                  <td>$5,000,000</td>
                                  <td>$20,000,000</td>
                              </tr>
                          </tbody></table>
                      </div>
                      
                      <p>
                          <u style="font-style:italic">${tc.bonus_tc_p41}</u><br><br>
                          ${tc.bonus_tc_p42}<br><br>
                          ${tc.bonus_tc_p43}
                      </p>
                      
                      <div class="table-wrapper">
                          <table class="table2 mt-4 mb-4 w-auto">
                              <tbody><tr>
                                  <th>${tc.th_balance}</th>
                                  <th>${tc.th_equity}</th>
                                  <th>${tc.th_margin_available}</th>
                                  <th>${tc.th_pending_bonus}</th>
                                  <th>${tc.th_volume_traded}</th>
                                  <th>${tc.th_volume_required}</th>
                              </tr>
                              <tr>
                                  <td>$1,500</td>
                                  <td>$1,500</td>
                                  <td>$1,500</td>
                                  <td>$200</td>
                                  <td>$10,000,000</td>
                                  <td>$20,000,000</td>
                              </tr>
                          </tbody></table>
                      </div>
                      
                      <p>
                          ${tc.bonus_tc_p44}<br><br>
                          ${tc.bonus_tc_p45}
                          <br><br>
                          <u style="font-style:italic">${tc.bonus_tc_p46}</u><br><br>
                          ${tc.bonus_tc_p47}
                          
                          <br><br>${tc.bonus_tc_p48}</p>
                      
                      <div class="table-wrapper">
                          <table class="table2 mt-4 mb-4 w-auto">
                              <tbody><tr>
                                  <th>${tc.th_balance}</th>
                                  <th>${tc.th_equity}</th>
                                  <th>${tc.th_margin_available}</th>
                                  <th>${tc.th_pending_bonus}</th>
                                  <th>${tc.th_volume_traded}</th>
                              </tr>
                              <tr>
                                  <td>$1,000</td>
                                  <td>$1,000</td>
                                  <td>$1,000</td>
                                  <td>$200</td>
                                  <td>$10,000,000</td>
                              </tr>
                          </tbody></table>
                      </div>
                      
                      <p>${tc.bonus_tc_p49}</p>
                      
                      <p>
                          <b>${tc.bonus_tc_p50}</b><br>
                          ${tc.bonus_tc_p51}
                          <br><br>
                          ${tc.bonus_tc_p52}
                          <br><br>
                          ${tc.bonus_tc_p53}
                      </p>
                      <p>
                          <b>${tc.bonus_tc_p54}</b><br>
                          ${tc.bonus_tc_p55}
                          <br><br>
                          ${tc.bonus_tc_p56}
                      </p>`,
          data_id: "",
          content_after: "",
        },

        {
            //id: "margin_information",
            id:'tc-view-24',
            title: tc.margin_information_title,
            content_before: `
                        <p>
                         ${tc.margin_information_p1}
                        <div class="table-wrapper">
                           <table class="table3 mt-4 mb-4">
                              <tbody>
                              <tr>
                                    <td>${tc.margin_information_p2}</td>
                                    <td style="">$4,995</td>
                                 </tr>
                                 <tr>
                                    <td>${tc.margin_information_p3}</td>
                                    <td style="">$2,500</td>
                                 </tr>
                                 <tr>
                                    <td>${tc.margin_information_p4}</td>
                                    <td style="">$2,495</td>
                                 </tr>
                                 <tr>
                                    <td>${tc.margin_information_p5}</td>
                                    <td style="color:green">50.05%</td>
                                 </tr>
                                 <tr>
                                    <td>${tc.margin_information_p6}</td>
                                    <td style="">$500</td>
                                 </tr>
                                 <tr>
                                    <td>${tc.margin_information_p7}</td>
                                    <td>$250,000</td>
                                 </tr>
                                 <tr>
                                    <td>${tc.margin_information_p8}</td>
                                    <td>1.80%</td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                        <ul class="list-style-disc-small mb-3">
                        <li>${tc.margin_information_p9_1}</li>
                           <li>${tc.margin_information_p9}</li>
                           
                           <li>${tc.margin_information_p11}<br>${tc.margin_information_p12}</li>
                           
                           
                           <li>${tc.margin_information_p13}<br>${tc.margin_information_p14}</li>
                           
                           <li>${tc.margin_information_p15}<br>${tc.margin_information_p16}
                           <br>
                           ${tc.margin_information_p17}</li>
                           
                           <li>${tc.margin_information_p18}</li>
                        </ul>
                        <b>${tc.margin_information_p19}</b><br>${tc.margin_information_p20}
                          <br>${tc.margin_information_p21}
                        <br><br>
                        <b><u><u>${tc.margin_information_p22}</u></u></b><br>
                        ${tc.margin_information_p23}
                      <br><br>
                        <b>${tc.margin_information_p24}</b><br>
                        ${tc.margin_information_p25}<br><br>
                        <ul class="list-style-disc-small mb-3">
                           <li>${tc.margin_information_open_deals}</li>
                           <ul class="list-style-disc-small empty-disc ml-4">
                              <li>${tc.margin_information_p26}</li>
                              <li>${tc.margin_information_p27}</li>
                              <li>${tc.margin_information_p28}</li>
                           </ul>
                           <li>${tc.margin_information_p29}</li>
                           <li>${tc.margin_information_p30}</li>
                        </ul>
                        
                        <p><b>${tc.margin_information_process}</b></p>
  
                        <ol>
                          <li>${tc.margin_information_p31}</li>
                          <li>${tc.margin_information_p32}</li>
                          <li>${tc.margin_information_p33}</li>
  
                        </ol>
                        <b>${tc.margin_information_p34}</b><br>
                        ${tc.margin_information_p35}<br><br>
                        <ul class="list-style-disc-small mb-3">
                          <li>${tc.margin_information_p36}</li>
                          <li>${tc.margin_information_p37}</li>
                          <li>${tc.margin_information_p38}</li>
                          <li>${tc.margin_information_p39}</li>
                          <li>${tc.margin_information_p40}</li>
                        </ul>
                        
                        <p>${tc.margin_information_p41}</p>
                        
                        <b>${tc.margin_information_p42}</b><br>
  
                        ${tc.margin_information_p43}<br><br>
  
                        <ul class="list-style-disc-small mb-3">
                          <li>${tc.margin_information_p44}</li>
                          <li>${tc.margin_information_p45}</li>
                           <li><b>${tc.margin_information_open_deals}</b></li>
                           <ul class="list-style-disc-small empty-disc ml-4">
                              <li>${tc.margin_information_p46}</li>
                              <li>${tc.margin_information_p47}</li>
                           </ul>
                           <li>${tc.margin_information_p48}</li>
                           <li>${tc.margin_information_p49}</li>
                        </ul>
  
                        <b>${tc.margin_information_process}</b><br>
                          <ol>
                              <li>${tc.margin_information_p50}</li>
                              <li>${tc.margin_information_p51}</li>
                              <li>${tc.margin_information_p52}</li>
                          </ol>
                        
                        </p>`,
            data_id: "",
            content_after: "",
          },


        {
          //id: "additional_trading_rules",
          id: "tc-view-25",
          title: tc.additional_tr_tab_title,
          content_before: `
              
  
              <p>
                    <b>${tc.additional_tr_p9is}</b><br>
                  ${tc.additional_tr_p10is}
                  <br><br>
                  <b>${tc.additional_tr_p9}</b><br>
                  ${tc.additional_tr_p10}
                  <br><br>
                  <b>${tc.additional_tr_p11}</b><br>
                  ${tc.additional_tr_p12}
                  <br><br>
                  <b>${tc.additional_tr_p13}</b><br>
                  ${tc.additional_tr_p14}
                  <br><br>
                  <b>${tc.additional_tr_p15}</b><br>
                  ${tc.additional_tr_p16}
              </p>
              
              <ul class="list-style-disc-small mt-3 mb-2">
                  <li>${tc.additional_tr_p17}</li>
                  <li>${tc.additional_tr_p18}</li>
                  <li>${tc.additional_tr_p19}</li>
                  <li>${tc.additional_tr_p20}</li>
              </ul>

              <p>${tc.additional_tr_p21}</p>
  
              <p>
                  <b>${tc.additional_tr_p22}</b><br>
                  ${tc.additional_tr_p23}
                  <br><br>
                  <b>${tc.additional_tr_p32}</b><br>
                  ${tc.additional_tr_p33}
                  <br><br>
                  <b>${tc.additional_tr_p24}</b><br>
                  ${tc.additional_tr_p25}
                  <br><br>
                  <b>${tc.additional_tr_p26}</b><br>
                  ${tc.additional_tr_p27}
                  <br><br>
                  ${tc.additional_tr_p28}
                  <br><br>
                  <b>${tc.additional_tr_p29}</b><br>
                  ${tc.additional_tr_p30}
                  <br><br>
                  ${tc.additional_tr_p31}
              </p>
              `,
          data_id: "",
          content_after: "",
        },
      ],
    },
    {
      id: "forex",
      title: tc.forex_tab_title,
      tabs: [
        {
          //id: "forex_overnight_financing",
          id: "tc-view-10",
          title: tc.forex_of_tab_title,
          content_before: `
                  <p>
                  ${tc.forex_of_p1}
                      <br><br>
                      ${tc.forex_of_p2}
                      <br><br>
                      ${tc.forex_of_p3}
                      <br><br>
                      <u><b><u>${tc.forex_of_p4}</u></b></u><br><br>
                      ${tc.forex_of_p5}
                      <br>
  
                    <div class="formula formula_f1">
                        <div class="formula-name">${tc.overnight_financing_percentage}</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">${tc.forex_of_f1}</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>
                    <br>
                    ${tc.forex_of_p6}
                      <br><br>
                      
                      <div class="formula formula_f2">
                        <div class="formula-name">${tc.overnight_financing_percentage}</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">${tc.forex_of_f2}</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>

                      <br><br>

                     ${tc.forex_of_p7}<br><br>
                     ${tc.forex_of_p8}
                      <br><br><br>
                      <u><b><u>${tc.forex_of_p9}</u></b></u><br><br>
                      <b>${tc.forex_of_p10}</b><br><br>
                      ${tc.forex_of_p11}
                      
                  </p>
  
                  <ul class="list-style-dashed mb-4">
                      <li>${tc.forex_of_p12}</li>
                      <li>${tc.forex_of_p13}</li>
                      <li>${tc.forex_of_p14}</li>
                      <li>${tc.forex_of_p15}</li>
                      <li>${tc.forex_of_p16}</li>
                      <li>${tc.forex_of_p17}</li>
                      <li>${tc.forex_of_p18}</li>
                  </ul>
                  <p>
                      ${tc.forex_of_p19}<br>
                      
                    <div class="formula formula_f3 mb-2" >
                        <div class="formula-name">${tc.overnight_financing_percentage}</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) + 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.0000611</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.00611%</div>
                    </div>

                    ${tc.forex_of_p20}
                      <br><br><br>

                      ${tc.forex_of_p21}
                      <br><br>
                      
                      <div class="formula formula_f4 mb-2" >
                        <div class="formula-name">${tc.overnight_financing_percentage}</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) - 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">0.00001944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">0.001944%</div>
                    </div>

                    ${tc.forex_of_p22}
                      <br><br><br>
                      
                      <b>${tc.forex_of_p23}</b><br><br>
                      
                      ${tc.forex_of_p24}
                  </p>
                  
                  <ul class="list-style-dashed mb-4">
                      <li>${tc.forex_of_p25}</li>
                      <li>${tc.forex_of_p26}</li>
                      <li>${tc.forex_of_p27}</li>
                      <li>${tc.forex_of_p28}</li>
                      <li>${tc.forex_of_p29}</li>
                      <li>${tc.forex_of_p30}</li>
                      <li>${tc.forex_of_p31}</li>
                  </ul>
                  
                  <p>
                      ${tc.forex_of_p32}<br>
                      
                        <div class="formula formula_f5 mb-2" >
                            <div class="formula-name">${tc.overnight_financing_percentage}</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.000663</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.0663%</div>
                        </div>

                    
                        ${tc.forex_of_p33}
                      <br><br><br>

                      ${tc.forex_of_p34}<br><br>
                      
                      <div class="formula formula_f6 mb-2" >
                            <div class="formula-name">${tc.overnight_financing_percentage}</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) - 0.14</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.000253</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.0253%</div>
                        </div>


                        ${tc.forex_of_p35}
                      <br><br><br>
                      <b>${tc.forex_of_p36}</b><br><br>
                      ${tc.forex_of_p37}
                  </p>
                  
                  <ul class="list-style-dashed mt-4 mb-4">
                      <li>${tc.forex_of_p38}</li>
                      <li>${tc.forex_of_p39}</li>
                      <li>${tc.forex_of_p40}</li>
                      <li>${tc.forex_of_p41}</li>
                      <li>${tc.forex_of_p42}</li>
                      <li>${tc.forex_of_p43}</li>
                      <li>${tc.forex_of_p44}</li>
                  </ul>
                  
                  <p>
                      ${tc.forex_of_p45}<br>
                      
                      
                      <div class="formula formula_f7 mb-2" >
                            <div class="formula-name">${tc.overnight_financing_percentage}</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.00001167</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.001167%</div>
                        </div>


                        ${tc.forex_of_p46}
                      <br><br><br>

                      ${tc.forex_of_p47}<br><br>
                      
                      <div class="formula formula_f8 mb-2" >
                            <div class="formula-name">${tc.overnight_financing_percentage}</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 - 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.0000533</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.00533%</div>
                        </div>

                        ${tc.forex_of_p48}
                  </p>`,
  
          data_id: "OvernightFinancing",
          content_after: `<p>${tc.forex_of_p49}</p>`,
          table_titles: [
            tc.forex_of_th1,
            tc.forex_of_th2,
            tc.forex_of_th3,
            tc.forex_of_th4
          ],
          view_id: ["Forex"],
        },
      ],
    },
    {
      id: "index_commodity_and_crypto_cfds",
      title: tc.index_tab_title,
      tabs: [
        {
          //id: "index_overnight_financing",
          id: "tc-view-11",
          title: tc.index_of_tab_title,
          content_before: `
              <p>
              ${tc.index_of_p1}
                  <br><br>
                  ${tc.index_of_p2}
                  <br><br>
                  ${tc.index_of_p3}
                  <br><br>
                  <u><b><u>${tc.index_of_p4}</u></b></u><br><br>
                  ${tc.index_of_p5}<br>
                  
                  <div class="formula formula_f9 mb-2">
                    <div class="formula-name">${tc.overnight_financing_percentage}</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">${tc.index_of_f1}</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                  ${tc.index_of_p6}<br><br>
                  
                  <div class="formula formula_f10 mb-2">
                    <div class="formula-name">${tc.overnight_financing_percentage}</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">${tc.index_of_f2}</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                  ${tc.index_of_p7}<br><br>${tc.index_of_p8}
                  <br><br><br>
                  <u><b><u>${tc.index_of_p9}</u></b></u><br><br>
                  <b>${tc.index_of_p10}</b><br><br>
                  ${tc.index_of_p11}
              </p>
  
              <ul class="list-style-dashed mb-2">
                  <li> ${tc.index_of_p12}</li>
                  <li> ${tc.index_of_p13}</li>
                  <li> ${tc.index_of_p14}</li>
                  <li> ${tc.index_of_p15}</li>
              </ul>
              <br>
  
              <p>
                   ${tc.index_of_p16}<br>
                  
                  <div class="formula formula_f11 mb-2">
                    <div class="formula-name">${tc.overnight_financing_percentage}</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 + 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0003351944</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.03351944%</div>
                </div>

                   ${tc.index_of_p17}
                  <br><br><br>
                   ${tc.index_of_p18}<br><br>
                  
                  <div class="formula formula_f12 mb-2">
                    <div class="formula-name">${tc.overnight_financing_percentage}</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 - 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.00019630556</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.019630556%</div>
                </div>

                   ${tc.index_of_p19}
                  <br><br><br>
                  <b> ${tc.index_of_p20}</b><br><br>
                   ${tc.index_of_p21}
              </p>
              
              <ul class="list-style-dashed mb-2">
                  <li> ${tc.index_of_p22}</li>
                  <li> ${tc.index_of_p23}</li>
                  <li> ${tc.index_of_p24}</li>
                  <li> ${tc.index_of_p25}</li>
              </ul>
              <br>
              <p>
                   ${tc.index_of_p26}
                  
                  <br>

                  <div class="formula formula_f13 mb-2">
                        <div class="formula-name">${tc.overnight_financing_percentage}</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 + 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00009944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.009944%</div>
                    </div>

                   ${tc.index_of_p27}
                  <br><br><br>
                  ${tc.index_of_p28}<br><br>
                  
                  <div class="formula formula_f14 mb-2">
                        <div class="formula-name">${tc.overnight_financing_percentage}</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00003944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.003944%</div>
                    </div>

                    ${tc.index_of_p29}
                  <br><br>
                  
                 
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>${tc.index_of_p30}</p>`,
          table_titles: [
            tc.th_instrument,
            tc.th_dofp_sell,
            tc.th_dofp_buy,
            tc.th_of_gmt
          ],
          view_id: ["Index", "Commodity", "Crypto"],
        },
        {
        //id: "contracts_rollover_dates",
        id: "tc-view-3",
          title: tc.contracts_rollover_dates_tab_title,
          content_before: `<p>
                    ${tc.contracts_rollover_dates_p1}
                      <br><br>
                      ${tc.contracts_rollover_dates_p2}
                      <br><br>
                      ${tc.contracts_rollover_dates_p3}
                      <br><br>
                      ${tc.contracts_rollover_dates_p4}
                      <br><br>
                      ${tc.contracts_rollover_dates_p5}
                  </p>`,
  
          data_id: "FuturesRollover",
          content_after: ``,
          table_titles: [tc.contracts_rollover_dates_th1, tc.contracts_rollover_dates_th2],
          view_id: ["Commodity", "Index"],
          products: [tc.contracts_rollover_dates_products1, tc.contracts_rollover_dates_products2],
        },
      ],
    },
    {
      id: "Share and ETF CFDs",
      title: tc.share_tab_title,
      tabs: [
        {
          //id: "shares_overnight_financing",
          id: "tc-view-12",
          title: tc.share_of_tab_title,
          content_before: `<p>
                 ${tc.share_of_p1}
                  <br><br>
                  ${tc.share_of_p2}
                  <br><br>
                  ${tc.share_of_p3}
                  <br><br>
                  <u><b><u>${tc.share_of_p4}</u></b></u><br><br>
                  ${tc.share_of_p5}
                  
                  <br>
                  
                  <div class="formula formula_f15 mb-2">
                    <div class="formula-name">${tc.overnight_financing_percentage}</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">${tc.share_of_f1}</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                ${tc.share_of_p6}

                <br><br>

                <div class="formula formula_f16 mb-2">
                    <div class="formula-name">${tc.overnight_financing_percentage}</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">${tc.share_of_f2}</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>


                  ${tc.share_of_p7}<br><br>
                  ${tc.share_of_p8}
                  <br><br><br>
                  <u><b><u>${tc.share_of_p9}</u></b></u><br><br>
                  <b>${tc.share_of_p10}</b><br><br>
                  ${tc.share_of_p11}
              </p>
  
              <ul class="list-style-dashed mb-4">
                  <li>${tc.share_of_p12}</li>
                  <li>${tc.share_of_p13}</li>
                  <li>${tc.share_of_p14}</li>
                  <li>${tc.share_of_p15}</li>
              </ul>
         
              <p>
                  ${tc.share_of_p16}<br>
                  
                <div class="formula formula_f17 mb-2">
                    <div class="formula-name">${tc.overnight_financing_percentage}</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0004</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.04%</div>
                </div>

                ${tc.share_of_p17}

                  <br><br><br>

                  ${tc.share_of_p18}<br><br>

                  <div class="formula formula_f18 mb-2">
                    <div class="formula-name">${tc.overnight_financing_percentage}</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.000125</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.0125%</div>
                </div>


                ${tc.share_of_p19}
                <br><br><br>

                  <b>${tc.share_of_p20}</b><br><br>
                  ${tc.share_of_p21}<br>
              </p>
  
              <ul class="list-style-dashed mb-2">
                  <li>${tc.share_of_p22}</li>
                  <li>${tc.share_of_p23}</li>
                  <li>${tc.share_of_p24}</li>
                  <li>${tc.share_of_p25}</li>
              </ul>
            <br>
              <p>
                  ${tc.share_of_p26}<br>

                  <div class="formula formula_f19 mb-2">
                    <div class="formula-name">${tc.overnight_financing_percentage}</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000169</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0169%</div>
                </div>
                  
                ${tc.share_of_p27}
                  <br><br><br>
                  ${tc.share_of_p28}<br><br>
                  
                <div class="formula formula_f20 mb-2">
                    <div class="formula-name">${tc.overnight_financing_percentage}</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000109</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0109%</div>
                </div>

                ${tc.share_of_p29}
            
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>${tc.share_of_p30}</p>`,
          table_titles: [
            tc.share_of_th1,
            tc.share_of_th2,
            tc.share_of_th3,
            tc.share_of_th4
          ],
          view_id: [ "Shares", "ETF"],
        },
        {
          //d: "dividends",
          id: "tc-view-7",
          title: tc.dividends_tab_title,
          content_before: `<p>
                    ${tc.dividends_p1}
                      <br><br>
                      <u>${tc.dividends_p2}</u><br>
                      ${tc.dividends_p3}<br>
                      ${tc.dividends_p4}<br>
                      ${tc.dividends_p5}<br>
                      ${tc.dividends_p6}<br>
                      ${tc.dividends_p7}<br>
                      ${tc.dividends_p8}
                      </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information: tc.dividends_no_info,
          table_titles: [
            tc.th_share_etf,
            tc.th_market,
            tc.th_dividend_amount,
            tc.th_date_time_gmt
          ],
          view_id: "1",
        },
        {
          //id: "corporate_actions",
          id: "tc-view-1",
          title: tc.stock_splits_tab_title,
          content_before: `<p>
              
           ${tc.stock_splits_p1}
          <br><br>
          ${tc.stock_splits_p2}
            <br><br>

            ${tc.stock_splits_p7}

            <br><br>

            <b>${tc.stock_splits_p3}</b><br>
                ${tc.stock_splits_p4}
                <br><br>
                ${tc.stock_splits_p5}
                <br><br>
                ${tc.stock_splits_p6}
              </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information: tc.stock_splits_no_info,
          table_titles: [
            tc.th_share_etf, 
            tc.th_market, 
            tc.th_type, 
            tc.th_date_time_gmt
        ]
        },
        {
          //id: "earnings_reports",
          id: "tc-view-22",
          title: tc.earnings_reports_tab_title,
          content_before: `<p>
                                  ${tc.earnings_reports_p1}
                                  <br><br>
                                  ${tc.earnings_reports_p2}
                                  
                              </p>`,
          data_id: "",
          content_after: "",
        },
      ],
    },
  ];
  
  export { content };
  